import APIs from '../common/config/APIs'
import defaultRestApi from '../common/config/RestApiInstance'
import querystring from 'query-string'
import isNil from 'lodash/isNil'
import cookie from "react-cookies";

export default class MemberServices {

    static getPreferences = () => {
        return defaultRestApi.get(APIs.preferencesURL()).catch(err => {
            //TODO : throw error
        });
    }
   

    static updatePreferences = (params) => {
        return defaultRestApi.post(APIs.preferencesURL(), 
        JSON.stringify(params),
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    )}

    static getAnnouncementAPI = () => {
        return defaultRestApi.get(APIs.announcementURL())
    }

    static getQuickStakeInfor = () => {
        return defaultRestApi.get(APIs.quickStakeURL())
    }

    static getStatement = (params) => {
        return defaultRestApi.get(APIs.getStatement(querystring.stringify(params))).catch(err => {
            //TODO : throw error
        });
    }
    
    static getListSports = (params) => {
        return defaultRestApi.get(APIs.resultsSportsURL(querystring.stringify(params))).catch(err => {
            //TODO : throw error
        });
    }

    static getLeaguesSport = (params) => {
        return defaultRestApi.get(APIs.resultsLeaguesURL(querystring.stringify(params))).catch(err => {
            //TODO : throw error
        });
    }

    static getEventsResult = (params) => {
        return defaultRestApi.get(APIs.resultsEventsURL(querystring.stringify(params))).catch(err => {
            //TODO : throw error
        });
    }

    static getAccountInfo = () => {
        return defaultRestApi.get(APIs.accountFullInfoURL()).catch(err => {
            //TODO : throw error
        });
    }
    static postLoginAPI = (loginId, password, captcha = "", captchaToken = "") => {
      const trustCodeStore = localStorage.getItem("trustCode");
      const trustCodeCookie = cookie.load('trustCode') || '';
      const data = JSON.parse(trustCodeStore);
      const trustCodeHeader = data && !isNil(data[loginId]) ? data[loginId] : ''
        return defaultRestApi.post(APIs.memberLoginURL(),
            querystring.stringify({
                loginId: loginId, //gave the values directly for testing
                password: password,
                captcha: captcha,
                captchaToken: captchaToken
            }), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Trust-Code": trustCodeHeader || trustCodeCookie
                }
            })
    }

    static postLogoutAPI = () => {
        return defaultRestApi.post(APIs.memberLogoutURL(), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
    }

    static getDataNoCacheAPI = () => {
        return defaultRestApi.get(APIs.dataNoCache(), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
    }

    static postAccountBalanceAPI = () => {
        return defaultRestApi.post(APIs.accountBalanceURL(), null, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": "XMLHttpRequest"
            }
        })
    }

    /**
     * Call fetching forecasts API
     */
    static getForecastAPI = (forecastParameters) => {
        return defaultRestApi.get(APIs.getForecastURL(forecastParameters),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    }

    /**
     * Call fetching multi forecasts API
     */
    static getMultiForecastAPI = (forecastParameters) => {
        return defaultRestApi.post(APIs.getMultiForecastURL(),
            forecastParameters,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    }
    static getIframeUrl = (params) => {
      return defaultRestApi.get(APIs.getIframeUrl(querystring.stringify(params)),{
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

    static getTeaserTicketAPI = (teaserParameters) => {
        return defaultRestApi.get(APIs.getTeaserTicketURL(teaserParameters));
    }

    static removeTeaserTicketAPI = (teaserParameters) => {
        return defaultRestApi.get(APIs.removeTeaserTicketURL(teaserParameters));
    }

    static getMyBetsAPI = () => {
        return defaultRestApi.get(APIs.getMyBetsURL(), {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    static getDeleteWagerAPI = (deleteParameters) => {
        return defaultRestApi.get(APIs.getDeleteMyBetsWager(deleteParameters),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    }

    static reportSystemError = (errorObject) => {
        return defaultRestApi.post(APIs.reportSystemErrorURL(),
            errorObject,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    }

    static getAcceptTC = (promoEmail, version) => {
        return defaultRestApi.get(APIs.acceptTCURL(promoEmail, version),
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        );
    }

    static getVersionTNC = (linkTNC) => {
        return defaultRestApi.get(linkTNC,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        );
    }

    static getCountryAndCurrency = () => {
        return defaultRestApi.get(APIs.memberGetCountryAndCurrency(), {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }

    static postDoForgotUsername = (data) => {
        return defaultRestApi.post(APIs.memberDoForgotUsername(),
           data, {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/json;charset=UTF-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static postDoForgotEmail = (data) => {
        return defaultRestApi.post(APIs.memberDoForgotEmail(),
            data, {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/json;charset=UTF-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static postDoForgotPassword = (data) => {
        return defaultRestApi.post(APIs.memberDoForgotPassword(),
            data, {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/json;charset=UTF-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static postDoSignUp = (data) => {
        return defaultRestApi.post(APIs.memberDoSignUp(),
            JSON.stringify(data), {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/json; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            })
    }

    static getSliderBannerHome = (params) => {
        return defaultRestApi.get(APIs.getSliderBannerHomeURL(params), {
            headers: {
                "Content-Type": "application/json"
            }
        })
    }

    static getMiniBanners = (params) => {
        return defaultRestApi.post(APIs.getAllMiniBannerURL(params), {
            headers: {
                "Content-Type": "application/json"
            }
        })
    }

    static getBanks = (countryCode) => {
        return defaultRestApi.post(APIs.memberGetBanks(),
            querystring.stringify({
                countryCode: countryCode
            }), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
                }
            });
    }

    static getWallets = (currency) => {
        return defaultRestApi.get(APIs.memberGetWallets(currency),
            null, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
    }

    static getAllActivePayments = () => {
        return defaultRestApi.get(APIs.memberGetActivePayments(), {
            headers: {
                "Content-Type": "application/json"
            }
        })
    }

    static getSupportedPaymentTypes = (bankId, txnType) => {
        return defaultRestApi.get(APIs.memberGetSupportedPaymentTypes() + "?bankId=" + bankId + "&txnType=DEPOSIT&platform=" + txnType,
            JSON.stringify({

            }), {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static getPinPayPaymentMethods = (data) => {
        return defaultRestApi.post(APIs.memberGetPinPayPaymentMethods(),
            querystring.stringify({
                tnxType: data.tnxType,
                platform: data.platform
            }), {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static getPinPaySupportedBanks = (data) => {
        return defaultRestApi.post(APIs.memberGetPinPaySupportedBanks(),
            querystring.stringify({
                tnxType: data.tnxType,
                platform: data.platform
            }), {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static addBankingAccountService = (data) => {
        return defaultRestApi.post(APIs.memberAddBankingAccount(),
            JSON.stringify({
                country: data.country,
                bankId: data.bankId,
                bankName: data.bankName,
                bankAccName: data.bankAccName,
                bankAccNo: data.bankAccNo,
                captcha: data.captcha
            }), {
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    static getCaptchaImage = (category) => {
        return defaultRestApi.get(APIs.getCaptchaImage(category),
            {
                headers: {
                    'Accept': '*/*',
                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }


    static activationLink = (data) => {
        return defaultRestApi.post(APIs.activationLink(),
            JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }
        )
    }

    /**
     * Get Accounts Balance API
     */
    static getAccountsBalanceAPI = () => {
      return defaultRestApi.get(APIs.getAccountsBalance(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        })
    }

    /**
     * Get active product wallet API
     */
    static getActiveProductWalletAPI = () => {
      return defaultRestApi.get(APIs.getActiveProductWallet(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        })
    }

    /**
     * Transfer Wallets API
     */
    static transferWalletsAPI = (data) => {
      return defaultRestApi.post(APIs.transferWallets(),
        querystring.stringify(data), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "X-Requested-With": "XMLHttpRequest"
          }
        }
      )
    }

    /**
     * Get game dispatcher Url API
     */
    static getGameDispatcherUrlAPI = (parameters) => {
      return defaultRestApi.get(APIs.getGameDispatcherUrl(querystring.stringify(parameters)),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Get AG game dispatcher Url API
     */
    static getAGGameDispatcherUrlAPI = (parameters) => {
      return defaultRestApi.get(APIs.getAGGameDispatcherUrl(querystring.stringify(parameters)),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

  /**
   * Get Solid game launcher Url
   */
  static getSolidGameLaunchPath = (gameCode) => {
    return defaultRestApi.get(APIs.getSolidGameLaunchPath(gameCode),
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
  }

    /**
     * Get casino login status API
     */
    static getCasinoLoginStatusAPI = () => {
      return defaultRestApi.get(APIs.getCasinoLoginStatus(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Get CR855 Game Path API
     */
    static getCR855GamePathAPI = () => {
      return defaultRestApi.get(APIs.getCR855GamePath(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Check Playtech player online
     */
    static checkPlaytechPlayerOnlineAPI = () => {
      return defaultRestApi.get(APIs.checkPlaytechPlayerOnline(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

     /**
     * Logout Playtech player 
     */
    static logoutPlaytechUserAPI = () => {
        return defaultRestApi.get(APIs.logoutPlaytechUser(),
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
      }

    /**
     * Get Playtech player
     */
    static getPlaytechPlayerAPI = () => {
      return defaultRestApi.get(APIs.getPlaytechPlayer(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Get Casino Backround
     */
    static getCasinoBackgroundAPI = (parameters) => {
      return defaultRestApi.get(APIs.getCasinoBackground(querystring.stringify(parameters)),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    /**
     * Check Affiliate Code
     */
    static checkAffiliateCode = (affiliateCode) => {
        return defaultRestApi.post(APIs.checkAffiliateCode(),
            querystring.stringify({'affiliateCode':affiliateCode}), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "X-Requested-With": "XMLHttpRequest"
            }
            }
        )
    }

    /**
     * Check Promo Code
     */
    static checkPromoCode = (promoCode, affiliateCode, country, currency) => {
        return defaultRestApi.post(APIs.checkPromoCode(),
            querystring.stringify({'promoCode':promoCode, 'affiliateCode':affiliateCode, 'country':country, 'currency':currency}), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "X-Requested-With": "XMLHttpRequest"
            }
            }
        )
    }

    /**
     * Get sport market for render the left menu
     */
    static getSportsMarkets = (country, v) => {
      return defaultRestApi.get(APIs.sportsMarketURL(country, v),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }
    /**
     * Get Playtech Game render the left menu
     */
    static getPlaytechGames = () => {
        return defaultRestApi.get(APIs.playtechGamesURL(),
            {
            headers: {
                "Content-Type": "application/json"
            }
            }
        )
    }

    /**
     * Get Playtech Game by ID
     */
    static getPlaytechGamesById = (id) => {
        return defaultRestApi.get(APIs.playtechGamesByIdURL(id),
            {
            headers: {
                "Content-Type": "application/json"
            }
            }
        )
    }

    /**
     * Get sport market for render the left menu
     */
    static getAsiaSportsMarkets = (country, v) => {
        return defaultRestApi.get(APIs.asiaSportsMarketURL(country, v),
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
      }

    /**
     * Get ngc url
     */
    static getNgcUrl = (page, lang) => {
        return defaultRestApi.get(APIs.getNgcUrl(page, lang),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }
    /**
     * Get profile
     */
    static getProfile = () => {
        return defaultRestApi.get(APIs.getProfile(),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
    }

    static changePassword = (params) => {
        return defaultRestApi.post(APIs.changePassword(), querystring.stringify(params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          }
        });
    }
    
    static changePasswordToLogin = (params) => {
        const trustCodeStore = localStorage.getItem("trustCode");
        const trustCodeCookie = cookie.load('trustCode') || '';
        const data = JSON.parse(trustCodeStore);
        const trustCodeHeader = data && !isNil(data[params.loginId]) ? data[params.loginId] : ''
        return defaultRestApi.post(APIs.changePasswordToLogin(), querystring.stringify(params), 
        {
          headers: {
            "Trust-Code": trustCodeHeader || trustCodeCookie
          }
        });
    }


    /**
     * Update locale
     */
    static updateLocale = (lang) => {
       return defaultRestApi.post(APIs.updateLocale(lang),
        {
            headers: {
              "Content-Type": "application/json"
            }
        }
      )
    }

    static getActiveWallets = () => {
        return defaultRestApi.get(APIs.getActiveWallets(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    static getStatements = (parameters) => {
      return defaultRestApi.get(APIs.getStatements(querystring.stringify(parameters)),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }
    
    static getActiveProducts = () => {
      return defaultRestApi.get(APIs.activeProductsURL(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    static getProductFilter = () => {
      return defaultRestApi.get(APIs.productFilterURL(),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    static getMessages = (params) => {
        return defaultRestApi.get(APIs.getMessages(querystring.stringify(params)));
    }

    static deleteMessages = (messageId) => {
        const data = {messageId: messageId};
        return defaultRestApi.post(APIs.deleteMessageListURL(), 
        querystring.stringify(data),
        {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
        });
    }

    static getLastMessages = (params) => {
        return defaultRestApi.get(APIs.lastMessageURL(querystring.stringify(params)));
    }

    static getAnnouncementList = (params) => {
        return defaultRestApi.get(APIs.announcementListURL(querystring.stringify(params)))
    }

    static getResultsSports = () => {
        return defaultRestApi.get(APIs.resultsSportsAsiaURL(),
        {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
    }

    static getResultsLeagues = (params) => {
        return defaultRestApi.get(APIs.resultsLeaguesAsiaURL(querystring.stringify(params)))
    }

    static requestActivation = (params) => {
        return defaultRestApi.post(APIs.requestActivationURL(),params,
        {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
    }

    static getB2BTransactionStatement = (params) => {
        return defaultRestApi.post(APIs.getB2BTransactionsURL(), querystring.stringify((params),{
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
        }))
    }

    /**
     * Call fetching maintenance template API
     */
    static getMaintenanceTemplate = () => {
      return defaultRestApi.get(APIs.getMaintenanceTemplate(),
          {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    }

    /**
     * Call fetching login message API
     */
    static getLoginMessage = () => {
      return defaultRestApi.get(APIs.getLoginMessage(),
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    }

    /**
     * Call fetching login message API
     */
    static readLoginMessage = () => {
      return defaultRestApi.post(APIs.readLoginMessage(),
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    }

    /**
     * Call fetching Prestige Club API
     */
    static getPrestigeClub = (params) => {
      return defaultRestApi.post(APIs.getPrestigeClubURL(querystring.stringify(params)),
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      );
    }

    static updateDefaultView = (view) => {
      return defaultRestApi.post(APIs.updateDefaultView(view),
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
    }

    static updateFingerPrintId = (params) => {
      defaultRestApi.post(APIs.updateFingerPrintId(querystring.stringify(params)), {
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      });
    }

    static getSportPeriodDesc = () => {
      return defaultRestApi.get(APIs.getSportPeriodDesc(), {
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      });
    }

    static getDisplayPeriod() {
      return defaultRestApi.get(APIs.getDisplayPeriod(), {
        headers: {  
          "Content-Type": "application/json; charset=utf-8"
        }
      });
    }
    static getActiveLink = (params) => {
      return defaultRestApi.get(APIs.getActiveLink(params), {
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      });
    }
  /**
   * Call to get mfa setting info 
   */
  static getMfaSettingInfo = () => {
    return defaultRestApi.get(APIs.getMfaSettingInfo(),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }

  /**
   * Call to set mfa method type
   */
  static setMfaMethodType = (params) => {
    return defaultRestApi.post(APIs.setMfaMethodType(querystring.stringify(params)),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }

  /**
   * Call to get QR code MFA
   */
  static getQRCode = () => {
    return defaultRestApi.get(APIs.getQRCode(),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }

  /**
   * Call to get secretKey MFA
   */
  static getSecretKey = () => {
    return defaultRestApi.get(APIs.getSecretKey(),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }
  /**
   * Call to save Qr otp 
   */
  static saveQrOtp = (params) => {
    return defaultRestApi.post(APIs.saveQrOtp(querystring.stringify(params)),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      }
    );
  }

  static getDGGameDispatcherUrl = (params) => {
    return defaultRestApi.get(APIs.getDGGameDispatcherUrl(querystring.stringify(params)),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      });
  }

  static acceptNewBetslipMobileNotify = () => {
    return defaultRestApi.get(APIs.newBetslipMobileNotify(),
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      });
  }

  static updateReasonDPFailed = (params) => {
    return defaultRestApi.get(APIs.getUpdateReasonDpFailedURL(querystring.stringify(params)),
    {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      }
    })
  }

  static pingToDPIframe = (params) => {
    return defaultRestApi.head(APIs.getDPIframeURL(querystring.stringify(params)));
  }
}


// WEBPACK FOOTER //
// ./src/app/services/MemberService.js